import { RootState } from '../../../base';

export const toolsSelectors = {
    getCreateCompanySuccess: (state: RootState) =>
        state.tools.uiState.createCompanySuccess,
    getCreateCompanyLoading: (state: RootState) =>
        state.tools.uiState.isPostCreateCompanyLoading,
    getCompanyCategories: (state: RootState) =>
        state.tools.jobQuestionsCategories,
    getChatsList: (state: RootState) => state.tools.chatsList,
    getActiveChatId: (state: RootState) => state.tools.activeChatId,
    getActiveChatMessages: (state: RootState) =>
        state.tools.activeChatHistory.chatHistory,
    getActiveChatQuestions: (state: RootState) =>
        state.tools.activeChatQuestions,
    getActiveChatHistory: (state: RootState) => state.tools.activeChatHistory,
    getActiveChatQuestionsLoading: (state: RootState) =>
        state.tools.uiState.isFetchActiveChatQuestionsLoading,
    getActiveChatHistoryLoading: (state: RootState) =>
        state.tools.uiState.isFetchChatHistoryLoading,
    getActiveCompany: (state: RootState) => state.tools.activeCompany,
    getActiveCompanyQuestionsCategory: (state: RootState) =>
        state.tools.activeCompanyQuestionsCategory,
    getActiveChatGeneratedContent: (state: RootState) =>
        state.tools.activeChatHistory.generatedContent,
    getPostCompanyQuestionAnswerLoading: (state: RootState) =>
        state.tools.uiState.isPostCompanyQuestionAnswerLoading,
    getIsAwaitingJobAssistantReply: (state: RootState) =>
        state.tools.uiState.isAwaitingJobAssistantReply,
    getActiveCompanyQuestionsHistory: (state: RootState) =>
        state.tools.activeCompanyQuestionsHistory,
    getActiveEditQuestionAnswer: (state: RootState) =>
        state.tools.activeEditQuestionAnswer,
};
